import React, { useState } from "react";
import { Dialog } from "@mui/material";
import PubLabDettPage from "./PubLabDettPage";
import PubLabInfiniteTable from "./PubLabInfiniteTable";
import LabConsolleDroppedPage from "../labConsolle/LabConsolleDroppedPage";
import LabConsolleClonePage from "../labConsolle/LabConsolleClonePage";
import LabConsolleRelaunchPage from "../labConsolle/LabConsolleRelaunchPage";
import LabConsolleManageUsersPage from "../labConsolle/LabConsolleManageUsersPage";
import LabConsolleManageProxyPage from "../labConsolle/ManageProxy/LabConsolleManageProxyPage";
import LabConsolleManageAppVolPage from "../labConsolle/LabConsolleManageAppVolPage";
import LabConsolleScheduleDettPage from "../labConsolle/LabConsolleScheduleDettPage";
import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query';


const queryClient = new QueryClient();


function PubLabPage(props) {
    const [selectedLabProps, setSelectedLabProps] = useState();
    const [isShowSelectedLab, setIsShowSelectedLab] = useState(false);
    const [isShowScheduleLab, setIsShowScheduleLab] = useState(false);
    const [isShowDropLab, setIsShowDropLab] = useState(false);
    const [isShowCloneLab, setIsShowCloneLab] = useState(false);
    const [isShowRelaunchLab, setIsShowRelaunchLab] = useState(false);
    const [isShowManageUsersLab, setIsShowManageUsersLab] = useState(false);
    const [isShowManageProxyLab, setIsShowManageProxyLab] = useState(false);
    const [isShowManageAppVolLab, setIsShowManageAppVolLab] = useState(false);

    return (
        <React.Fragment>
            <QueryClientProvider client={queryClient}>
                <PubLabInfiniteTable
                    apiAuthResponse={props.apiAuthResponse}
                    apiAuthGroups={props.apiAuthGroups}
                    setSelectedLabProps={setSelectedLabProps}
                    setIsShowSelectedLab={setIsShowSelectedLab}
                    setIsShowScheduleLab={setIsShowScheduleLab}
                    setIsShowDropLab={setIsShowDropLab}
                    setIsShowCloneLab={setIsShowCloneLab}
                    setIsShowRelaunchLab={setIsShowRelaunchLab}
                    setIsShowManageUsersLab={setIsShowManageUsersLab}
                    setIsShowManageProxyLab={setIsShowManageProxyLab}
                    setIsShowManageAppVolLab={setIsShowManageAppVolLab}
                    isAdmin={props.isAdmin}
                />
            </QueryClientProvider>

            <Dialog fullScreen open={isShowSelectedLab} onClose={() => setIsShowSelectedLab(false)}>
                <PubLabDettPage
                    labProps={selectedLabProps}
                    apiAuthResponse={props.apiAuthResponse}
                    apiAuthName={props.apiAuthName}
                    apiAuthSurname={props.apiAuthSurname}
                    apiAuthGroups={props.apiAuthGroups}
                    setIsShowSelectedLab={setIsShowSelectedLab}
                    isAdmin={props.isAdmin}
                />
            </Dialog>

            <Dialog fullScreen open={isShowScheduleLab} onClose={() => setIsShowScheduleLab(false)}>
                <LabConsolleScheduleDettPage
                    labProps={selectedLabProps}
                    setSelectedLabProps={setSelectedLabProps}
                    apiAuthResponse={props.apiAuthResponse}
                    apiAuthName={props.apiAuthName}
                    apiAuthSurname={props.apiAuthSurname}
                    apiAuthGroups={props.apiAuthGroups}
                    setIsShowScheduleLab={setIsShowScheduleLab}
                    isAdmin={props.isAdmin}
                />
            </Dialog>

            <Dialog fullScreen open={isShowDropLab} onClose={() => setIsShowDropLab(false)}>
                <LabConsolleDroppedPage
                    labProps={selectedLabProps}
                    apiAuthResponse={props.apiAuthResponse}
                    apiAuthName={props.apiAuthName}
                    apiAuthSurname={props.apiAuthSurname}
                    apiAuthGroups={props.apiAuthGroups}
                    setIsShowDropLab={setIsShowDropLab}
                    isAdmin={props.isAdmin}
                />
            </Dialog>

            <Dialog fullScreen open={isShowCloneLab} onClose={() => setIsShowCloneLab(false)}>
                <LabConsolleClonePage
                    labProps={selectedLabProps}
                    apiAuthResponse={props.apiAuthResponse}
                    apiAuthName={props.apiAuthName}
                    apiAuthSurname={props.apiAuthSurname}
                    apiAuthGroups={props.apiAuthGroups}
                    setIsShowCloneLab={setIsShowCloneLab}
                    isAdmin={props.isAdmin}
                />
            </Dialog>

            <Dialog fullScreen open={isShowRelaunchLab} onClose={() => setIsShowRelaunchLab(false)}>
                <LabConsolleRelaunchPage
                    labProps={selectedLabProps}
                    apiAuthResponse={props.apiAuthResponse}
                    apiAuthName={props.apiAuthName}
                    apiAuthSurname={props.apiAuthSurname}
                    apiAuthGroups={props.apiAuthGroups}
                    setIsShowRelaunchLab={setIsShowRelaunchLab}
                    isAdmin={props.isAdmin}
                />
            </Dialog>

            <Dialog fullScreen open={isShowManageUsersLab} onClose={() => setIsShowManageUsersLab(false)}>
                <LabConsolleManageUsersPage
                    labProps={selectedLabProps}
                    apiAuthResponse={props.apiAuthResponse}
                    apiAuthName={props.apiAuthName}
                    apiAuthSurname={props.apiAuthSurname}
                    apiAuthGroups={props.apiAuthGroups}
                    setIsShowManageUsersLab={setIsShowManageUsersLab}
                    isAdmin={props.isAdmin}
                />
            </Dialog>

            <Dialog fullScreen open={isShowManageProxyLab} onClose={() => setIsShowManageProxyLab(false)}>
                <LabConsolleManageProxyPage
                    labProps={selectedLabProps}
                    apiAuthResponse={props.apiAuthResponse}
                    apiAuthName={props.apiAuthName}
                    apiAuthSurname={props.apiAuthSurname}
                    apiAuthGroups={props.apiAuthGroups}
                    setIsShowManageProxyLab={setIsShowManageProxyLab}
                    isAdmin={props.isAdmin}
                />
            </Dialog>

            <Dialog fullScreen open={isShowManageAppVolLab} onClose={() => setIsShowManageAppVolLab(false)}>
                {isShowManageAppVolLab && (
                    <LabConsolleManageAppVolPage
                        labProps={selectedLabProps}
                        setSelectedLabProps={setSelectedLabProps}
                        apiAuthResponse={props.apiAuthResponse}
                        apiAuthName={props.apiAuthName}
                        apiAuthSurname={props.apiAuthSurname}
                        apiAuthGroups={props.apiAuthGroups}
                        setIsShowManageAppVolLab={setIsShowManageAppVolLab}
                        isAdmin={props.isAdmin}
                        queryClient={queryClient}
                    />
                )}
            </Dialog>
        </React.Fragment>
    );


}

export default PubLabPage;
